module.exports = __webpack_public_path__ + "static/propagation-icon-70px-305f0622f522fb0b635b900dd0418ea1.svg";